module.exports = __webpack_public_path__ + "static/media/search-gray-icon.46f0ac24.svg";